import type { QueryClient } from '@tanstack/react-query';

/** The cached balances a completed credit purchase changes. */
const CREDIT_BALANCE_QUERY_KEYS = [
  ['getBuilderCredits'],
  ['getLlmCredits'],
  ['getLlmUsage'],
  ['getInboxPreviewsUsageSummaries'],
  ['getInboxPreviewsUsageLog'],
];

/** Invalidates the cached credit balances so a completed purchase is reflected on the page. */
export async function invalidateCreditBalances(queryClient: QueryClient): Promise<void> {
  await Promise.all(CREDIT_BALANCE_QUERY_KEYS.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
}
